module.exports = __webpack_public_path__ + "static/img/8.6e44350.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/8.png
// module id = L44x
// module chunks = 3